<template>
  <div class="sidebar">
    <slot />
  </div>
</template>

<style scoped>
.sidebar {
  --visible-width: 3.5rem;
  clip-path: inset(0 calc(100% - var(--visible-width)) 0 0);
  transition: var(--transition-default);
  position: fixed;
  left: 0;
  box-shadow: var(--box-shadow-down);
  margin-top: calc(var(--gap-xs) * -1);
  &:hover {
    --visible-width: 12.5rem;
    clip-path: inset(0 0 0 0);
  }
}
</style>
